<template>
  <img
    v-if="iconUrl"
    class="icon-mask"
    :width="size"
    loading="lazy"
    :height="size"
    :src="iconUrl"
    role="presentation"
    :style="{
      '--icon-url': `url(${iconUrl})`,
      '--unit': `${pxToRem(size)}`,
      '--size': `${size}`,
    }"
  />
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import { TailwindColorNames } from 'src/types/helpers';

  interface Props {
    type?: string;
    color?: TailwindColorNames | 'black';
  }
  const props = withDefaults(defineProps<Props>(), {
    color: 'black',
    type: '',
  });
  /**
   * Converts pixel size to rem and accepts the base as second argument. default base is 16px
   */
  function pxToRem(px: number | string, base = 16) {
    let tempPx = px;
    if (typeof tempPx === 'string') tempPx = tempPx.replace('px', '');

    tempPx = Number(tempPx);
    return (1 / base) * tempPx + 'rem';
  }
  const iconBaseUrl = 'https://www.volvocars.com/static/shared/icons/v2/';
  const size = ref(23);

  const iconUrl = computed(() => getIconUrl(props.type));

  function getIconUrl(path: string | undefined) {
    if (!path || !path.startsWith('volvo-')) {
      return false;
    }
    const iconName = path.replaceAll('volvo-', '');
    size.value = Number(path.slice(-2));
    return `${iconBaseUrl}${iconName}.svg`;
  }
</script>
